import { TanstackSortingFn } from "./TableSorting";

export const buildGroupedPermissionOptions = (permissions = []) => {
  if (!Array.isArray(permissions)) return [];

  const grouped = permissions.reduce((acc, perm) => {
    const category =
      perm.category ||
      perm.name.split(":")[0].replace(/_/g, " ").trim() ||
      "General";

    if (!acc[category]) acc[category] = [];

    acc[category].push({
      value: String(perm.id),
      label:
        perm.name
          .split(":")[1]
          ?.replace(/_/g, " ")
          .replace(/\b\w/g, (l) => l.toUpperCase())
          .trim() || perm.name,
      description: perm.description || "",
    });

    return acc;
  }, {});

  const sortedGroupKeys = Object.keys(grouped).sort((a, b) =>
    TanstackSortingFn({ getValue: () => a }, { getValue: () => b }, "category")
  );

  return sortedGroupKeys.map((group) => ({
    group,
    items: grouped[group].sort((a, b) =>
      TanstackSortingFn(
        { getValue: () => a.label },
        { getValue: () => b.label },
        "label"
      )
    ),
  }));
};
